import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DropDownOption, ValueChangeEvent } from '@interfaces/form.interface';

@Component({
  selector: 'ark-select-checkbox',
  templateUrl: './select-checkbox.component.html',
  styleUrls: ['./select-checkbox.component.scss'],
})
export class SelectCheckboxComponent {
  @Input() label!: string;
  @Input() placeholder = 'Select...';

  private _items: DropDownOption[] = [];
  get items(): DropDownOption[] {
    return this._items;
  }
  @Input() set items(v: DropDownOption[]) {
    this._items = v;

    if (v) {
      this.buildItemNames();
    }
  }

  @Output() itemChanged = new EventEmitter<{
    event: ValueChangeEvent;
    option: DropDownOption;
  }>();
  @Output() itemsChanged = new EventEmitter<DropDownOption[]>();

  @ViewChild('ref', { static: true })
  ref!: ElementRef;

  opened = false;
  itemNames!: string;

  constructor() {}

  toggle() {
    this.opened = !this.opened;
  }

  buildItemNames() {
    const selectedItems = this.items.filter((e) => e.selected);
    this.itemNames = selectedItems.map((e) => e.name).join(', ');
  }

  itemChange(item: DropDownOption, event: ValueChangeEvent) {
    item.selected = event.value;
    this.buildItemNames();

    this.itemChanged.emit({ event: event, option: item });
    this.itemsChanged.emit(this.items.filter((e) => e.selected));
  }

  @HostListener('document:click', ['$event.target'])
  public clickOutside(target: any): void {
    if (this.opened) {
      const inside = this.ref.nativeElement.contains(target);
      if (!inside) {
        this.opened = false;
      }
    }
  }
}
